import React from "react";
import { motion } from "framer-motion";
import { useState } from "react";
import { useDispatch } from "react-redux";
import Backdrop from "../Misc/Backdrop";

import { Button } from "../Ui/button";

import { addUpload, fetchUploads } from "../../features/programUpload";
const dropIn = {
  hidden: { y: "-100vh", opacity: 0 },
  visible: {
    y: "0",
    opacity: 1,
    transition: {
      duration: 0.1,
      type: "spring",
      damping: 25,
      stiffness: 500,
    },
  },
  exit: { y: "100vh", opacity: 0 },
};
const AddUploadModal = ({ props }) => {
  const dispatch = useDispatch();

  const initialUser = {
    name: "",
    description: "",
    programId: props.programId,
    required: false,
  };
  const [upload, setUpload] = useState(initialUser);

  const submit = async (e) => {
    try {
      e.stopPropagation();
      e.preventDefault();
      await dispatch(addUpload(upload));
      await dispatch(fetchUploads());
      props.handleClose();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Backdrop onClick={props.handleClose}>
      <motion.div
        className="ab rounded w-[45rem] bg-white dark:bg-wc-gradient bg-cover text-wc-green dark:text-white shadow-md font-sans"
        onClick={(e) => e.stopPropagation()}
        variants={dropIn}
        initial="hidden"
        animate="visible"
        exit="exit"
        transition={{ duration: 0.5 }}
      >
        <div className="w-full p-8 flex flex-col gap-4 line-clamp-7 ">
          <div className=" rounded w-full flex gap-2 items-center justify-start ">
            <h2 className="text-lg font-bold text-center flex gap-2 text-blue-reef">
              {/*<FaUserPlus size="24" />*/}
              Add New Document Field
            </h2>
          </div>
          <div className="flex flex-col ">
            <span className=" text-blue-reef">Document Name</span>
            <input
              type="text"
              className="text-black rouh-text-inputnded  border-2 border-gray-300 rounded h-[2.5rem] pl-2"
              placeholder=" Name"
              name="uploadName"
              onChange={(e) => {
                setUpload((prev) => ({
                  ...prev,
                  name: e.target.value,
                }));
              }}
            />
          </div>
          <div className="flex flex-col ">
            <span className=" text-blue-reef">Document Description</span>
            <textarea
              className="text-black rouh-text-inputnded  border-2 border-gray-300 resize-none h-32 rounded p-2"
              placeholder=" Description"
              name="uploadDescription"
              rows={3}
              onChange={(e) => {
                setUpload((prev) => ({
                  ...prev,
                  description: e.target.value,
                }));
              }}
            />
          </div>
          <div className="flex flex-col ">
            <div className="flex gap-4">
              <label>Required Field ?</label>
              <input
                type="checkbox"
                onChange={(e) => {
                  setUpload((prev) => ({
                    ...prev,
                    required: e.target.checked,
                  }));
                }}
              ></input>
            </div>
          </div>

          {/* <motion.button
            whileHover={{ scale: 1 }}
            whileTap={{ scale: 1 }}
            className="marginXAuto text-white bg-green-reef hover:bg--700 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2 mr-2 dark:bg-green-400 dark:hover:bg-green-reef focus:outline-none dark:focus:ring-green-500"
            onClick={(e) => {
              submit(e);
            }}
          >
            SAVE
          </motion.button> */}
          <Button
            variant="outline"
            className="bg-green-reef text-white rounded ml-auto w-2/12"
            onClick={(e) => {
              submit(e);
            }}
          >
            Save
          </Button>
        </div>
      </motion.div>
    </Backdrop>
  );
};

export default AddUploadModal;
